import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home";
import About from "./Components/About";
import API from "./Components/API";
import CDMO from "./Components/CDMO";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import ScrollToTop from './Components/ScrollToTop';
import ManufacturingQuality from "./Components/ManufacturingQuality";
import Investors from "./Components/Investors";
import Intermediates from "./Components/Intermediates";
import Animals from "./Components/AnimalHealth";
import Careers from "./Components/Careers";
import Humans from "./Components/HumanHealth";
// import Sustainability from "./Components/sustainability";
import Sustainability from "./Components/Sustainability";
import CorporateGovernance from "./Components/CorporateGovernance";
import Financial from "./Components/Financial";
// import Leadership from "./Components/leaderShip";
import BoardOfDirectors from "./Components/boardOfDirectors";
import CompositeScheme from "./Components/composite_schema";
import InvestorContacts from "./Components/InvestorContacts";
import ShareholderInformation from "./Components/ShareholderInformation";
import StockExchangeCorrespondence from "./Components/StockExchangeCorrespondence";
import AnnualReports from "./Components/AnnualReports";
import Policies from "./Components/Policies";

import DiclosureUnderRegulation from "./Components/DiclosureUnderRegulation";
// import Businesses from "./Components/Businesses";

const InProgress = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <h2 style={{ fontSize: '2rem', color: '#003399', marginBottom: '10px' }}>Page is In Progress</h2>
    <p style={{ fontSize: '1.2rem', color: '#555' }}>We are working to bring this page to you soon.</p>
  </div>
);

function App() {
  return (
    <>
      <ScrollToTop />
      <div style={{ display: "flex", flexDirection: "column", margin: 0, padding: 0 }}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/api" element={<API />} />
          <Route path="/cdmo" element={<CDMO />} />
          <Route path="/manufacturing-quality" element={<ManufacturingQuality />} />
          <Route path="/investor-relation" element={<Investors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/intermediates" element={<Intermediates />} />
          <Route path="*" element={<InProgress />} />
          <Route path="/animal-health" element={<Animals />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/human-health" element={<Humans />} />
          {/* <Route path="/sustainability-csr" element={<Sustainability />} /> */}
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/CorporateGovernance" element={<CorporateGovernance />} />
          <Route path="/financial" element={<Financial />} />
          <Route path="/investor-contacts" element={<InvestorContacts />} />
          <Route path="/shareholder-information" element={<ShareholderInformation />} />
          <Route path="/stock-exchange-correspondence" element={<StockExchangeCorrespondence />} />
          <Route path="/annual-reports" element={<AnnualReports />} />
          <Route path="/board-of-directors" element={<BoardOfDirectors />} />
          <Route path="/composite-scheme" element={<CompositeScheme />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/disclosure-under-regulation" element={<DiclosureUnderRegulation />} />
          {/* <Route path="/businesses" element={<Businesses />} /> */}
        </Routes>
        <Footer />
      </div>

    </>

  );
}
export default App;